import useReveal from '../../hooks/useReveal';

// Wraps a section so it fades and rises gently into place the first time it
// scrolls into view, instead of appearing all at once on page load.
function Reveal({ children, className = '', as: Component = 'div', ...rest }) {
  const [ref, isVisible] = useReveal();

  return (
    <Component ref={ref} className={`Reveal ${isVisible ? 'is-visible' : ''} ${className}`.trim()} {...rest}>
      {children}
    </Component>
  );
}

export default Reveal;
